(function () {
  // Zweisprachigkeit (P1, Juli 2026): die UI-Sprache folgt Shopifys Sprachwahl —
  // reservierung.liquid schreibt request.locale in data-locale, init() setzt LANG/FMT.
  // NICHT lokalisiert (bewusst): Cart-Property-KEYS (Datum/Menü/_hold … = Vertrag mit
  // BTA/Webhook, docs in ~/rareres BTA-FIRST.md) und FOH-gerichtete WERTE („2× Standard",
  // „Gast 1 (Omni): …" = Küchensprache). Editorial aus der App (Jahreszeiten, Intro,
  // Storno-Text) kommt serverseitig und bleibt bis P2 deutsch.
  var LANG = "de";
  var FMT = "de-DE";
  var I18N = {
    de: {
      reserve: "Reservieren", waitlist: "Warteliste",
      stFewTable: "Wenige Tische", stLastTable: "Letzter Tisch", stFewSeat: "Wenige Plätze", stLastSeat: "Letzter Platz", stFull: "Ausgebucht",
      noProduct: "Kein Produkt konfiguriert.",
      groupHint1: "Mehr als ", groupHint2: " Personen? Bitte ",
      more: "Mehr",
      notBookable: "Dieses Erlebnis ist noch nicht buchbar (keine Shopify-Variante verknüpft).",
      occasion: "Ihre Nachricht an uns", occasionPh: "Optional",
      seatQ: "Möchten Sie einen bestimmten Tisch?",
      seatTable1: "Ein Tisch für Sie", seatTable2: "Ein Tisch für zwei",
      seatTableTxt: "Mit Blick auf den Messing-Pass, an dem jeder Teller entsteht — die klassische Wahl.",
      seatTheke: "An der offenen Küche",
      seatThekeDesc: "Drei Tische stehen direkt am Tresen, die Küche zum Greifen nah.",
      thekeShort1: "noch einer frei", thekeShort2: "noch zwei frei", thekeShort3: "noch drei frei",
      thekeGoneShort: "an diesem Abend vergeben", thekeGoneHint: "Donnerstags stehen die Chancen am besten.",
      seatStein: "Ihr Platz: der Steintisch am Weinschrank",
      seatSteinTxt: "Die einzelnen Tische dieses Abends sind vergeben — wir decken für Sie am großen Steintisch ein: Ihr Platz an einem Ende, Ihre Tischnachbarn weit am anderen.",
      seatSum: "Ihr Platz", seatSumTheke: "An der offenen Küche", seatSumStein: "Der Steintisch",
      seatTaken: "Dieser Platz wurde soeben vergeben — bitte wählen Sie neu.",
      timerHeld1: "Ihre Auswahl wird ", timerHeld2: " Minuten für Sie reserviert",
      timerGone: "Reservierung abgelaufen — bitte erneut wählen.",
      fullForParty1: "Dieser Abend ist für ", fullForParty2: " Personen leider ausgebucht.",
      resUnavailable: "Reservierung derzeit nicht möglich.",
      holdFailed: "Konnte nicht reservieren. Bitte erneut versuchen.",
      reservation: "Reservierung", oClock: " Uhr", perPerson: " pro Person",
      stepSelect: "Auswahl", stepDetails: "Details", stepExtras: "Extras", stepPay: "Zahlung",
      closeAria: "Schließen",
      paxLabel: "Anzahl Personen", menuLabel: "Menü", pp: " p. P.",
      cancel: "Abbrechen", back: "Zurück", next: "Weiter",
      menuPerGuest: "Menü & Hinweise — pro Gast", guest: "Gast ",
      menuStd: "Standard", menuVeg: "Vegetarisch",
      vegOnlyNote: "In dieser Jahreszeit kochen wir rein vegetarisch — das Menü ist für alle Gäste vegetarisch.",
      allergyPh: "Allergie / Unverträglichkeit (optional)",
      extrasIntro: "Optional — alles hier ist freiwillig. Weiter geht es zur Übersicht.",
      passDesc: "Alle 7 Menüs des Jahres, vollständig im Voraus. Dieser Abend ist Ihr erster Termin — die weiteren stimmen Sie mit uns ab.",
      minBackers1: " · ab ", minBackers2: " Zusagen",
      pledge: "Vormerken", pledged: "✓ Vorgemerkt",
      pledgePrompt: "E-Mail für die Benachrichtigung, sobald genug Gäste zusammenkommen:",
      pkgTotal: " · Gesamtpaket", onRequest: " · auf Anfrage",
      onRequestDesc: "Auf Anfrage — wird erst nach Bestätigung durch das Restaurant berechnet (nicht jetzt fällig).",
      confirmFollows: "Bestätigung folgt durch das Restaurant.",
      grpArrival: "Anreise & Übernachtung", grpEvening: "Am Abend", grpAddon: "Zusatzoptionen",
      passTeaserBody: "Mit dem 7-Jahreszeiten-Pass sichern Sie mehrere Abende der Saison im Voraus, vollständig vorab abgerechnet. ",
      passTeaserLink: "Zum 7-Jahreszeiten-Pass ›",
      passTeaserToggle: "Sie kommen öfter? Diesen Abend als ersten eines Jahreszeiten-Passes  +",
      rowPass: " Pass", rowMenu: " Menü",
      dueNowFull: "Jetzt fällig (voll)", dueNow: "Jetzt fällig", restOnsite: "Rest vor Ort",
      onRequestParen: " (auf Anfrage)", later: " – später",
      notePass: "7-Jahreszeiten-Pass: alle 7 Menüs des Jahres, vollständig im Voraus. Dieser Abend ist Ihr erster Termin — die weiteren stimmen Sie mit dem Restaurant ab. ",
      noteDeposit: "Anzahlung ", noteRest: ", Restbetrag vor Ort", noteFull: " (Vollvorkasse)",
      noteConfirmed: ". Ihre Reservierung ist sofort bestätigt. ",
      noteCheckout: "Weiter geht es zur sicheren Zahlung über Shopify — dort hinterlegen Sie Ihre Kontaktdaten und können unseren Newsletter abonnieren.",
      toPayment: "Weiter zur Zahlung", oneMoment: "Einen Moment …",
      holdGoneAlert: "Die Reservierung ist abgelaufen. Bitte wählen Sie erneut.",
      checkoutFailed: "Konnte nicht zum Checkout. Bitte erneut versuchen.",
      cancellation: "Stornierung bis 48 Stunden vor dem Termin kostenfrei — die Anzahlung wird erstattet.",
      wlSub: "Dieser Abend ist ausgebucht — wir benachrichtigen Sie, sobald ein Platz frei wird.",
      wlName: "Name", wlNamePh: "Ihr Name",
      wlPhone: "Telefon", wlPhonePh: "Für die schnelle Rückmeldung",
      wlEmail: "E-Mail (optional)", wlEmailPh: "Für die Bestätigung",
      wlNeedName: "Bitte Ihren Namen angeben.",
      wlNeedPhone: "Bitte eine Telefonnummer angeben — das ist unser schnellster Draht zu Ihnen.",
      wlSubmit: "Auf die Warteliste", wlDone: "✓ Eingetragen",
      wlDoneNote: "Wir melden uns telefonisch, sobald ein Platz frei wird.",
      close: "Schließen",
      wlFailed: "Konnte nicht eintragen. Bitte erneut versuchen.",
      seasonKicker: "Kulinarische Jahreszeit", menuLink: "Menükarte ansehen ›",
      loading: "Lädt …",
      fallbackPhone1: "Online-Reservierung gerade nicht möglich — bitte telefonisch: ",
      fallbackGeneric: "Reservierung gerade nicht möglich. Bitte später erneut versuchen.",
      dropHead: "Nächste Abende werden freigeschaltet — ", now: "jetzt",
      days: " Tage ", hrs: " Std ", mins: " Min",
      dropEmailPh: "E-Mail — wir erinnern Sie", remindMe: "Erinnere mich", notified: "✓ Wir benachrichtigen Sie.",
      noEvenings: "Zurzeit keine Abende veröffentlicht.",
      metaDefault: "Zum Metamorphose-Abend",
      byPhone: "Telefonisch: ", onRequestStatus: "Auf Anfrage",
      evening: " Abend", evenings: " Abende",
      giftcard: "Einen Abend verschenken — Geschenkgutschein ›",
      fromTime: "ab ", fromTimeSuffix: " Uhr", preview: " · Vorabzugang",
    },
    en: {
      reserve: "Reserve", waitlist: "Waiting list",
      stFewTable: "Few tables left", stLastTable: "Last table", stFewSeat: "Few seats left", stLastSeat: "Last seat", stFull: "Fully booked",
      noProduct: "No product configured.",
      groupHint1: "More than ", groupHint2: " guests? Please contact ",
      more: "More",
      notBookable: "This experience cannot be booked online yet.",
      occasion: "Your message to us", occasionPh: "Optional",
      seatQ: "Would you like a particular table?",
      seatTable1: "A table for you", seatTable2: "A table for two",
      seatTableTxt: "With a view of the brass pass, where every plate takes shape — the classic choice.",
      seatTheke: "By the open kitchen",
      seatThekeDesc: "Three tables sit right at the counter, the kitchen within arm's reach.",
      thekeShort1: "one left", thekeShort2: "two left", thekeShort3: "three left",
      thekeGoneShort: "taken this evening", thekeGoneHint: "Thursdays offer the best chances.",
      seatStein: "Your seat: the stone table by the wine cabinet",
      seatSteinTxt: "This evening's individual tables are taken — we'll set our large stone table for you: your places at one end, your table neighbours far at the other.",
      seatSum: "Your seat", seatSumTheke: "By the open kitchen", seatSumStein: "The stone table",
      seatTaken: "This seat was just taken — please choose again.",
      timerHeld1: "Your selection is held for you for ", timerHeld2: " minutes",
      timerGone: "Hold expired — please choose again.",
      fullForParty1: "This evening is fully booked for ", fullForParty2: " guests.",
      resUnavailable: "Reservations are currently not possible.",
      holdFailed: "Could not hold your table. Please try again.",
      reservation: "Reservation", oClock: "", perPerson: " per person",
      stepSelect: "Selection", stepDetails: "Details", stepExtras: "Extras", stepPay: "Payment",
      closeAria: "Close",
      paxLabel: "Number of guests", menuLabel: "Menu", pp: " p. p.",
      cancel: "Cancel", back: "Back", next: "Continue",
      menuPerGuest: "Menu & notes — per guest", guest: "Guest ",
      menuStd: "Standard", menuVeg: "Vegetarian",
      vegOnlyNote: "During this season our kitchen is entirely vegetarian — the menu is vegetarian for all guests.",
      allergyPh: "Allergy / intolerance (optional)",
      extrasIntro: "Optional — everything here is voluntary. Continue to the summary.",
      passDesc: "All 7 menus of the year, paid fully in advance. This evening is your first date — the others are arranged with us.",
      minBackers1: " · from ", minBackers2: " pledges",
      pledge: "Reserve interest", pledged: "✓ Noted",
      pledgePrompt: "Email for the notification once enough guests have joined:",
      pkgTotal: " · package price", onRequest: " · on request",
      onRequestDesc: "On request — only charged after confirmation by the restaurant (not due now).",
      confirmFollows: "Confirmation will follow from the restaurant.",
      grpArrival: "Arrival & accommodation", grpEvening: "During the evening", grpAddon: "Additional options",
      passTeaserBody: "With the 7 Seasons Pass you secure several evenings of the season in advance, fully prepaid. ",
      passTeaserLink: "About the 7 Seasons Pass ›",
      passTeaserToggle: "Coming more often? Make this evening the first of a Seasons Pass  +",
      rowPass: " pass", rowMenu: " menu",
      dueNowFull: "Due now (in full)", dueNow: "Due now", restOnsite: "Balance at the restaurant",
      onRequestParen: " (on request)", later: " – later",
      notePass: "7 Seasons Pass: all 7 menus of the year, paid fully in advance. This evening is your first date — the others are arranged with the restaurant. ",
      noteDeposit: "Deposit ", noteRest: ", balance payable at the restaurant", noteFull: " (paid in full)",
      noteConfirmed: ". Your reservation is confirmed immediately. ",
      noteCheckout: "You will continue to Shopify's secure payment, where you enter your contact details and can subscribe to our newsletter.",
      toPayment: "Continue to payment", oneMoment: "One moment …",
      holdGoneAlert: "The hold has expired. Please choose again.",
      checkoutFailed: "Could not reach checkout. Please try again.",
      cancellation: "Free cancellation up to 48 hours before the evening — the deposit is refunded.",
      wlSub: "This evening is fully booked — we will notify you as soon as a table becomes available.",
      wlName: "Name", wlNamePh: "Your name",
      wlPhone: "Phone", wlPhonePh: "For a quick reply",
      wlEmail: "Email (optional)", wlEmailPh: "For the confirmation",
      wlNeedName: "Please enter your name.",
      wlNeedPhone: "Please enter a phone number — it is the fastest way for us to reach you.",
      wlSubmit: "Join the waiting list", wlDone: "✓ Added",
      wlDoneNote: "We will call you as soon as a table becomes available.",
      close: "Close",
      wlFailed: "Could not add you. Please try again.",
      seasonKicker: "Culinary season", menuLink: "View the menu ›",
      loading: "Loading …",
      fallbackPhone1: "Online reservations are currently unavailable — please call: ",
      fallbackGeneric: "Reservations are currently unavailable. Please try again later.",
      dropHead: "The next evenings will be released — ", now: "now",
      days: " days ", hrs: " hrs ", mins: " min",
      dropEmailPh: "Email — we will remind you", remindMe: "Remind me", notified: "✓ We will notify you.",
      noEvenings: "No evenings published at the moment.",
      metaDefault: "About the Metamorphose evening",
      byPhone: "By phone: ", onRequestStatus: "On request",
      evening: " evening", evenings: " evenings",
      giftcard: "Give an evening — gift card ›",
      fromTime: "from ", fromTimeSuffix: "", preview: " · early access",
    },
  };
  function T(key) {
    var d = I18N[LANG] || I18N.de;
    return d[key] != null ? d[key] : I18N.de[key] != null ? I18N.de[key] : key;
  }
  function ACTION(state) { return state === "waitlist" ? T("waitlist") : T("reserve"); }
  // Knappheits-Wort hängt vom Bestuhlungsmodell ab: Dinner = Einzeltische ("… Tisch"),
  // Metamorphose = Shared Table ("… Platz"). Backend liefert nur den state, Wort wählt das Widget.
  function statusWord(state, productType) {
    var seat = productType === "metamorphose";
    if (state === "few") return seat ? T("stFewSeat") : T("stFewTable");
    if (state === "last") return seat ? T("stLastSeat") : T("stLastTable");
    if (state === "waitlist") return T("stFull");
    return "";
  }
  var LOW = { few: true, last: true };

  function fmtWeekday(iso) {
    return new Date(iso + "T00:00:00").toLocaleDateString(FMT, { weekday: "long" });
  }
  function fmtDay(iso) {
    return new Date(iso + "T00:00:00").toLocaleDateString(FMT, { day: "numeric", month: "long" });
  }
  function weekdayNum(iso) {
    return new Date(iso + "T00:00:00").getDay();
  }

  function init(root) {
    // Sprachwahl des Shops (Liquid: request.locale) → UI-Sprache + Datums-/Zahlenformat.
    var loc = (root.getAttribute("data-locale") || "de").toLowerCase();
    LANG = loc.indexOf("en") === 0 ? "en" : "de";
    FMT = LANG === "en" ? "en-GB" : "de-DE";
    var productId = root.getAttribute("data-product-id");
    var variantId = root.getAttribute("data-variant-id");
    var menuPrice = Number(root.getAttribute("data-menu-price") || "255");
    var deposit = Number(root.getAttribute("data-deposit") || "60");
    var boxVariant = (root.getAttribute("data-box-variant") || "").trim();
    var boxPrice = Number(root.getAttribute("data-box-price") || "60");
    var boxLabel = root.getAttribute("data-box-label") || "Versuchsküche-Box";
    var boxDesc = root.getAttribute("data-box-desc") || "";
    var passUrl = (root.getAttribute("data-pass-url") || "").trim();
    var passVariant = (root.getAttribute("data-pass-variant") || "").trim();
    var passPrice = Number(root.getAttribute("data-pass-price") || "1610");
    var passLabel = root.getAttribute("data-pass-label") || "7-Jahreszeiten-Pass";
    var courses = (root.getAttribute("data-courses") || "").trim(); // z. B. "11 Gänge" — in der Modal-Kopfzeile
    var giftcardUrl = (root.getAttribute("data-giftcard-url") || "").trim();
    var boxFrom = (root.getAttribute("data-box-from") || "").trim();
    var boxTo = (root.getAttribute("data-box-to") || "").trim();
    var groupContact = (root.getAttribute("data-group-contact") || "").trim();
    var maxParty = Number(root.getAttribute("data-max-party") || "6");
    // Vegetarische Jahreszeit (Theme-Setting, JJJJ-MM-TT): Abende im Fenster buchen alle Gäste
    // vegetarisch — die Standard/Vegetarisch-Wahl im Modal entfällt (Allergien bleiben pro Gast).
    var vegFrom = (root.getAttribute("data-veg-from") || "").trim();
    var vegTo = (root.getAttribute("data-veg-to") || "").trim();
    // Quelle seit 17.10.2026: vegetarische Jahreszeiten der Redaktion (Server, data.vegOnly) —
    // das Theme-Fenster bleibt nur als manuelle Übersteuerung.
    var vegRanges = [];
    function vegOnlyDate(date) {
      if (vegFrom && vegTo && date >= vegFrom && date <= vegTo) return true;
      for (var i = 0; i < vegRanges.length; i++) {
        if (date >= vegRanges[i].from && date <= vegRanges[i].to) return true;
      }
      return false;
    }
    // Platzwahl: Theken-Karte gilt für ABENDE ab diesem Datum (Team 04.09.); seats kommt vom Server.
    var thekeAb = (root.getAttribute("data-theke-ab") || "2026-10-01").trim();
    var seatsData = { thekeMax: 3, byDate: {}, splits: {} };
    var fallbackPhone = (root.getAttribute("data-fallback-phone") || "").trim();
    var list = root.querySelector("[data-etz-list]");
    var introEl = root.querySelector("[data-etz-intro]");
    var party = Number(root.getAttribute("data-party") || "2");
    var openingTime = "18:30";
    var phone = "";
    // Storno-Text: Default lokalisiert; der Server-Wert (data.cancellation) ist Editorial und
    // bis P2 deutsch — in EN bleiben wir deshalb beim lokalisierten Default.
    var cancellation = T("cancellation");
    // Discovery: ?ref aus der URL durchreichen — schaltet ein verstecktes Erlebnis frei (proxy.events).
    var refToken = "";
    try { refToken = (new URLSearchParams(window.location.search).get("ref") || "").trim(); } catch (e) { refToken = ""; }
    // Drop-Countdown (nächste öffentliche Welle) — serverseitig vorberechnet, ein Wert.
    var dropInfo = null;

    function euro(n) {
      return n.toLocaleString(FMT) + " €";
    }
    function btn(cls, label, onClick) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = cls;
      b.textContent = label;
      if (onClick) b.addEventListener("click", onClick);
      return b;
    }
    function field(label, type, placeholder) {
      var wrap = document.createElement("label");
      wrap.className = "etz-modal__field";
      var l = document.createElement("span");
      l.textContent = label;
      var input = type === "textarea" ? document.createElement("textarea") : document.createElement("input");
      if (placeholder) input.placeholder = placeholder;
      wrap.appendChild(l);
      wrap.appendChild(input);
      return { wrap: wrap, input: input };
    }

    if (!productId) {
      list.innerHTML = '<p class="etz-res__muted">' + T("noProduct") + "</p>";
      return;
    }

    // Hinweis „größere Gruppe → persönliche Anfrage" (mailto/tel), wiederverwendet.
    function paxGroupHint() {
      if (!groupContact) return null;
      var hint = document.createElement("div");
      hint.className = "etz-res__group-hint";
      var mail = /@/.test(groupContact);
      hint.innerHTML =
        T("groupHint1") + maxParty + T("groupHint2") +
        (mail
          ? '<a href="mailto:' + groupContact + '">' + groupContact + "</a>"
          : '<a href="tel:' + groupContact.replace(/\s/g, "") + '">' + groupContact + "</a>");
      return hint;
    }

    // Geteilter Personen-Picker: 1–4 direkt, „Mehr" klappt 5..max auf (UX-Standard statt
    // nacktem „+"); ab > max verweist der Hinweis auf die persönliche Anfrage. In Filter,
    // Buchungs-Modal und Warteliste genutzt.
    function renderPaxPicker(container, opts) {
      var base = Math.min(4, opts.max);
      var expanded = opts.current > base;
      function draw() {
        container.innerHTML = "";
        var upto = expanded ? opts.max : base;
        for (var n = 1; n <= upto; n++) {
          (function (k) {
            var b = document.createElement("button");
            b.type = "button";
            b.className = opts.btnClass + (k === opts.current ? " " + opts.activeClass : "");
            b.textContent = String(k);
            b.addEventListener("click", function () { opts.onPick(k); });
            container.appendChild(b);
          })(n);
        }
        if (!expanded && opts.max > base) {
          var more = document.createElement("button");
          more.type = "button";
          more.className = opts.btnClass + " etz-pax-more";
          more.textContent = T("more");
          more.addEventListener("click", function () { expanded = true; draw(); });
          container.appendChild(more);
        } else if (expanded && opts.withGroupHint) {
          var h = paxGroupHint();
          if (h) container.appendChild(h);
        }
      }
      draw();
    }

    // Buchungs-Modal — 3 Schritte (Auswahl · Details · Zahlung) mit Hold-Timer, wie im Prototyp
    function openModal(ev) {
      // Singleton: Doppelklick auf „Reservieren" darf nicht zwei gestapelte Modals
      // (und zwei Server-Holds) erzeugen.
      if (document.querySelector(".etz-modal")) return;
      // Pro Erlebnis: Variante/Preis/Anzahlung/Zeit/Titel (Fallback = Block-Defaults).
      var evProductId = (ev.product && ev.product.id) || productId;
      var evVariant = (ev.product && ev.product.variantId) || variantId;
      var evMenuPrice = (ev.product && ev.product.price) || menuPrice;
      var evDeposit = (ev.product && ev.product.deposit) || deposit;
      var evOpening = (ev.product && ev.product.openingTime) || openingTime;
      var evTitle = (ev.product && ev.product.title) || "";
      if (!evVariant) {
        alert(T("notBookable"));
        return;
      }
      var modalParty = party;
      // Vegetarische Jahreszeit: an diesen Abenden gibt es nur das vegetarische Menü.
      var evVegOnly = vegOnlyDate(ev.date);
      var defaultMenu = evVegOnly ? "vegetarisch" : "standard";
      var menus = [];
      var allergies = [];
      for (var i = 0; i < modalParty; i++) { menus.push(defaultMenu); allergies.push(""); }
      // Platzwahl (reduzierte Etappe): Theken-Karte + 2×2-Endgame. Zustand je Abend vom Server.
      var evSeats = (seatsData.byDate && seatsData.byDate[ev.date]) || { theke: [], stein: [] };
      var evSplit = (seatsData.splits && seatsData.splits[ev.date]) || null;
      var selectedSeat = null; // null = „Ein Tisch" | "theke" | "stein" (Endgame, automatisch)
      var seatOpen = false; // Frage auf/zu über Re-Renders hinweg merken
      function steinEndgame() { return !!(evSplit && evSplit.endgame && evSplit.frei > 0 && modalParty <= 2); }
      function thekeFrei() { return Math.max(0, 3 - ((evSeats.theke || []).length)); }
      function thekeWaehlbar() {
        if (ev.date < thekeAb || modalParty > 2 || thekeFrei() < 1) return false;
        if (modalParty === 1) { for (var i = 0; i < (evSeats.theke || []).length; i++) if (evSeats.theke[i] <= 1) return false; }
        return true;
      }
      var addonBox = false;
      var usePass = false;
      // Wählbare Preis-Stufen (Menü kurz/lang). Vorgewählt = serverseitig aufgelöste Stufe.
      var evTiers = (ev.product && ev.product.tiers) || [];
      var selectedTier = null;
      for (var ti = 0; ti < evTiers.length; ti++) {
        if (String(evTiers[ti].variantId) === String(evVariant)) { selectedTier = evTiers[ti]; break; }
      }
      function applyTier(t) {
        selectedTier = t;
        if (t.variantId) evVariant = t.variantId;
        if (t.deposit != null) evDeposit = t.deposit;
        if (t.fullPrice != null) evMenuPrice = t.fullPrice;
      }
      // Zusatzpakete (Add-ons) — Auswahl per Code. Gruppen-Add-ons (Kickstarter) laufen über Vormerken.
      var evAddons = (ev.product && ev.product.addons) || [];
      var selectedAddons = {};
      // Pass nur für reguläre Dinner-Abende (nicht Metamorphose/Sonderevents).
      var passAvailable = !!passVariant && !(ev.product && ev.product.type && ev.product.type !== "dinner");
      // Extras-Schritt nur zeigen, wenn es dort etwas gibt (Pass, Box oder Add-ons) — sonst überspringen.
      function hasExtras() { return passAvailable || boxVisible() || evAddons.length > 0; }
      var reservationId = null;
      var heldStartAt = null; // UTC-Slot-Beginn aus dem Hold → Cart-Property _date_iso8601 (BTA-Buchungszeit)
      var heldParty = null;
      var remaining = 0;
      var timer = null;
      var bannerEl = null;

      var overlay = document.createElement("div");
      overlay.className = "etz-modal";
      function close() {
        if (timer) clearInterval(timer);
        overlay.remove();
      }
      overlay.addEventListener("click", function (e) {
        if (e.target === overlay) close();
      });
      var card = document.createElement("div");
      card.className = "etz-modal__card";
      overlay.appendChild(card);
      // Schließen-× — Delegation, da header() das innerHTML je Schritt neu setzt.
      card.addEventListener("click", function (e) {
        if (e.target && e.target.closest && e.target.closest("[data-close]")) close();
      });

      var fOcc = field(T("occasion"), "text", T("occasionPh"));

      function mmss(s) {
        var m = Math.floor(s / 60);
        return (m < 10 ? "0" + m : m) + ":" + (s % 60 < 10 ? "0" + (s % 60) : s % 60);
      }
      function updateBanner() {
        if (!bannerEl) return;
        bannerEl.innerHTML =
          remaining > 0
            ? '<span class="etz-modal__dot"></span>' + T("timerHeld1") + "<strong>" + mmss(remaining) + "</strong>" + T("timerHeld2")
            : '<span class="etz-modal__dot"></span>' + T("timerGone");
      }
      function startTimer(secs) {
        if (timer) clearInterval(timer);
        remaining = secs;
        updateBanner();
        timer = setInterval(function () {
          remaining -= 1;
          updateBanner();
          if (remaining <= 0) clearInterval(timer);
        }, 1000);
      }
      // Tisch halten (für modalParty); re-hold bei Personen-Änderung.
      // Cart-Token mitschicken: im BTA-Modus verknüpft BTA die bezahlte Order über
      // genau diesen Token mit der Reservierung (Engine-Modus ignoriert ihn).
      function ensureHold(then) {
        // Headless-/Crawler-Guard (26.07.2026): Nach der /en-Publikation klickten automatisierte
        // Browser „Reservieren" (5 Holds in 8 s, je eigener Cart-Token) und blockierten mit
        // 15-Min-Holds echte Kapazität → „Ausgebucht"-Fenster. navigator.webdriver ist bei
        // Automation true, bei echten Gästen nie: Bots durchlaufen das Modal ohne Server-Hold
        // und scheitern in Schritt 4 am remaining<=0-Check — kein Hold, kein Cart-Müll.
        if (navigator.webdriver) { then(); return; }
        // Hold nur wiederverwenden, wenn er zur Personenzahl passt UND noch läuft — ein
        // abgelaufener Hold darf den Gast nicht weiter durch die Schritte tragen.
        if (reservationId && heldParty === modalParty && remaining > 0) {
          then();
          return;
        }
        // Re-Hold (z. B. Personenzahl geändert): den alten Hold serverseitig freigeben,
        // sonst blockiert er bis zu 15 Min Kapazität (verwaister Hold).
        var releaseId = reservationId || undefined;
        fetch("/cart.js")
          .then(function (r) { return r.json(); })
          .catch(function () { return {}; })
          .then(function (cart) {
        return fetch("/apps/etz/reserve", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ productId: evProductId, date: ev.date, party: modalParty, cartToken: (cart && cart.token) || undefined, releaseId: releaseId, seat: selectedSeat || undefined }),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (h) {
            if (h.status === "seat_taken") {
              // Der gewünschte Platz wurde parallel vergeben: lokal als voll markieren,
              // KEIN stiller Fallback auf „Ein Tisch" — der Gast wählt bewusst neu.
              if (selectedSeat === "theke") evSeats.theke = [2, 2, 2];
              if (selectedSeat === "stein" && evSplit) evSplit.frei = 0;
              selectedSeat = null;
              alert(T("seatTaken"));
              renderStep1();
              return;
            }
            if (h.status !== "held") {
              close();
              alert(
                h.status === "waitlist"
                  ? T("fullForParty1") + modalParty + T("fullForParty2")
                  : T("resUnavailable"),
              );
              load();
              return;
            }
            reservationId = h.reservationId;
            heldStartAt = h.startAt || null;
            heldParty = modalParty;
            startTimer((h.holdMinutes || 15) * 60);
            then();
          })
          .catch(function () {
            close();
            alert(T("holdFailed"));
          });
          });
      }

      function header(step) {
        return (
          '<button class="etz-modal__close" type="button" data-close="1" aria-label="' + T("closeAria") + '">×</button>' +
          '<div class="etz-modal__eyebrow">' + (evTitle || T("reservation")) + "</div>" +
          '<div class="etz-modal__title">' + fmtWeekday(ev.date) + ", " + fmtDay(ev.date) + "</div>" +
          '<div class="etz-modal__sub">' + evOpening + T("oClock") + " · " + (courses ? courses + " · " : "") + euro(evMenuPrice) + T("perPerson") + "</div>" +
          '<div class="etz-modal__steps">' +
          '<span class="' + (step === 1 ? "is-on" : "") + '">' + T("stepSelect") + "</span> · " +
          '<span class="' + (step === 2 ? "is-on" : "") + '">' + T("stepDetails") + "</span> · " +
          (hasExtras() ? '<span class="' + (step === 3 ? "is-on" : "") + '">' + T("stepExtras") + "</span> · " : "") +
          '<span class="' + (step === 4 ? "is-on" : "") + '">' + T("stepPay") + "</span></div>"
        );
      }
      function mountBanner() {
        if (!reservationId) return; // ohne Hold (webdriver-Guard) keinen irreführenden Timer zeigen
        bannerEl = document.createElement("div");
        bannerEl.className = "etz-modal__timer";
        updateBanner();
        card.appendChild(bannerEl);
      }
      function row2(l, r) {
        return '<div class="etz-modal__sumrow"><span>' + l + "</span><span>" + r + "</span></div>";
      }
      function menuSummary() {
        var veg = menus.filter(function (m) { return m === "vegetarisch"; }).length;
        var std = menus.length - veg;
        var parts = [];
        if (std) parts.push(std + "× Standard");
        if (veg) parts.push(veg + "× Vegetarisch");
        return parts.join(", ");
      }

      // Schritt 1 — Auswahl (Personenzahl)
      function renderStep1() {
        card.innerHTML = header(1);
        if (reservationId) mountBanner();

        var lab = document.createElement("div");
        lab.className = "etz-modal__field";
        var ls = document.createElement("span");
        ls.textContent = T("paxLabel");
        lab.appendChild(ls);
        var grid = document.createElement("div");
        grid.className = "etz-modal__paxgrid";
        renderPaxPicker(grid, {
          current: modalParty, max: maxParty, btnClass: "etz-modal__pax", activeClass: "is-on",
          withGroupHint: true,
          onPick: function (k) {
            modalParty = k;
            menus = [];
            allergies = [];
            for (var j = 0; j < modalParty; j++) { menus.push(defaultMenu); allergies.push(""); }
            // Kein Re-Hold beim Umschalten — der Hold entsteht/aktualisiert sich erst beim
            // „Weiter" (ensureHold prüft heldParty und gibt einen alten Hold via releaseId frei).
            renderStep1();
          },
        });
        lab.appendChild(grid);
        card.appendChild(lab);

        // ── Platzwahl (Variante A „Die stille Wahl", 05.09.2026) ──────────────────
        if (steinEndgame()) {
          // Endgame-2×2: die einzige Zwangs-Ansage — Geste, keine Wahl (Erwartungsmanagement
          // darf nie zugeklappt sein). Der Text stimmt wörtlich: Server sendet endgame nur,
          // wenn die Einzeltische des Abends wirklich vergeben sind.
          selectedSeat = "stein";
          var sa = document.createElement("div");
          sa.className = "etz-modal__seatauto";
          sa.innerHTML = "<span>" + T("seatStein") + '</span><p class="etz-seatdesc">' + T("seatSteinTxt") + "</p>";
          card.appendChild(sa);
        } else if (modalParty <= 2 && ev.date >= thekeAb) {
          if (selectedSeat === "theke" && !thekeWaehlbar()) selectedSeat = null;
          var det = document.createElement("details");
          det.className = "etz-modal__seatq";
          det.open = seatOpen;
          det.addEventListener("toggle", function () { seatOpen = det.open; });
          var sm = document.createElement("summary");
          sm.innerHTML = '<span class="etz-chev">›</span>' + T("seatQ");
          det.appendChild(sm);
          // Zeile = Punkt + Titel (+ leise Knappheit rechts) + Beschreibung nur unter der Wahl.
          var seatRow = function (sel, dim, availTxt, title, descTxt, onPick) {
            var l = document.createElement("label");
            l.className = "etz-seatopt" + (sel ? " is-sel" : "") + (dim ? " is-dim" : "");
            var html = '<span class="etz-seatdot"></span>';
            if (availTxt) html += '<span class="etz-seatavail">' + availTxt + "</span>";
            html += '<span class="etz-seatt">' + title + "</span>";
            if (descTxt) html += '<p class="etz-seatdesc">' + descTxt + "</p>";
            l.innerHTML = html;
            if (!dim && onPick) l.addEventListener("click", function () { seatOpen = true; onPick(); renderStep1(); });
            return l;
          };
          var frei = thekeFrei();
          var ok2 = thekeWaehlbar();
          det.appendChild(seatRow(!selectedSeat, false, null,
            modalParty === 1 ? T("seatTable1") : T("seatTable2"),
            !selectedSeat ? T("seatTableTxt") : null,
            function () { selectedSeat = null; }));
          det.appendChild(seatRow(selectedSeat === "theke", !ok2,
            ok2 ? (frei >= 3 ? T("thekeShort3") : frei === 2 ? T("thekeShort2") : T("thekeShort1")) : T("thekeGoneShort"),
            T("seatTheke"),
            selectedSeat === "theke" ? T("seatThekeDesc") : (!ok2 ? T("thekeGoneHint") : null),
            function () { selectedSeat = "theke"; }));
          card.appendChild(det);
        } else {
          selectedSeat = null; // 3+ Personen oder Abend vor der Theken-Phase: keine Wahl
        }

        // Menü-Länge / Preis-Stufe — nur wenn das Erlebnis mehrere wählbare Stufen hat.
        if (evTiers.length > 1) {
          var tl = document.createElement("div");
          tl.className = "etz-modal__field";
          var tls = document.createElement("span");
          tls.textContent = T("menuLabel");
          tl.appendChild(tls);
          var tgrid = document.createElement("div");
          tgrid.className = "etz-modal__tiergrid";
          evTiers.forEach(function (t) {
            var tb = document.createElement("button");
            tb.type = "button";
            var on = selectedTier && selectedTier.variantId === t.variantId;
            tb.className = "etz-modal__tier" + (on ? " is-on" : "");
            var price = t.fullPrice != null ? t.fullPrice : evMenuPrice;
            tb.innerHTML = '<span class="etz-modal__tier-l">' + t.label + '</span><span class="etz-modal__tier-p">' + euro(price) + T("pp") + "</span>";
            tb.addEventListener("click", function () { applyTier(t); renderStep1(); });
            tgrid.appendChild(tb);
          });
          tl.appendChild(tgrid);
          card.appendChild(tl);
        }

        var actions = document.createElement("div");
        actions.className = "etz-modal__actions";
        actions.appendChild(btn("etz-modal__cancel", T("cancel"), close));
        actions.appendChild(btn("etz-modal__go", T("next"), function () {
          ensureHold(renderStep2);
        }));
        card.appendChild(actions);
      }

      // Schritt 2 — Details (Menü je Gast, Allergien, Nachricht)
      function renderStep2() {
        card.innerHTML = header(2);
        mountBanner();

        var mWrap = document.createElement("div");
        mWrap.className = "etz-modal__field";
        var mLabel = document.createElement("span");
        mLabel.textContent = T("menuPerGuest");
        mWrap.appendChild(mLabel);
        // Vegetarische Jahreszeit: keine Menü-Wahl — ein Hinweis statt der Buttons.
        if (evVegOnly) {
          var vNote = document.createElement("p");
          vNote.className = "etz-modal__note";
          vNote.textContent = T("vegOnlyNote");
          mWrap.appendChild(vNote);
        }
        menus.forEach(function (cur, idx) {
          var g = document.createElement("div");
          g.className = "etz-modal__guest";
          // Kopf: Label links, Menü-Auswahl rechts (wie im Prototyp).
          var head = document.createElement("div");
          head.className = "etz-modal__guest-head";
          var gl = document.createElement("span");
          gl.className = "etz-modal__guest-l";
          gl.textContent = menus.length > 1 ? T("guest") + (idx + 1) : T("menuLabel");
          head.appendChild(gl);
          var menu = document.createElement("div");
          menu.className = "etz-modal__guest-menu";
          if (evVegOnly) {
            var fixed = document.createElement("span");
            fixed.className = "etz-modal__opt is-on";
            fixed.textContent = T("menuVeg");
            menu.appendChild(fixed);
          } else ["standard", "vegetarisch"].forEach(function (opt) {
            var b = document.createElement("button");
            b.type = "button";
            b.className = "etz-modal__opt" + (menus[idx] === opt ? " is-on" : "");
            b.textContent = opt === "standard" ? T("menuStd") : T("menuVeg");
            b.addEventListener("click", function () {
              menus[idx] = opt;
              renderStep2();
            });
            menu.appendChild(b);
          });
          head.appendChild(menu);
          g.appendChild(head);
          // Allergie je Gast — volle Breite unter den Menü-Buttons (so ist klar, welcher Teller betroffen ist).
          var al = document.createElement("input");
          al.type = "text";
          al.className = "etz-modal__allergy";
          al.placeholder = T("allergyPh");
          al.value = allergies[idx] || "";
          al.addEventListener("input", function () { allergies[idx] = al.value; });
          g.appendChild(al);
          mWrap.appendChild(g);
        });
        card.appendChild(mWrap);
        card.appendChild(fOcc.wrap);

        var actions = document.createElement("div");
        actions.className = "etz-modal__actions";
        actions.appendChild(btn("etz-modal__cancel", T("back"), renderStep1));
        actions.appendChild(btn("etz-modal__go", T("next"), function () { (hasExtras() ? renderStep3 : renderStep4)(); }));
        card.appendChild(actions);
      }

      // Schritt 3 — Zahlung (Add-on, Übersicht, Pass)
      // Add-on nur im definierten Zeitfenster (bezogen auf den Abend) anbieten.
      function boxVisible() {
        if (!boxVariant) return false;
        if (boxFrom && ev.date < boxFrom) return false;
        if (boxTo && ev.date > boxTo) return false;
        return true;
      }

      // Schritt 3 — Extras (Pass, Box, Zusatzoptionen). Nur Auswahl; die Summe folgt in Schritt 4.
      function renderStep3() {
        card.innerHTML = header(3);
        mountBanner();

        var intro = document.createElement("p");
        intro.className = "etz-modal__note";
        intro.textContent = T("extrasIntro");
        card.appendChild(intro);

        if (passAvailable) {
          var passRow = document.createElement("label");
          passRow.className = "etz-modal__addonbox";
          var pcb = document.createElement("input");
          pcb.type = "checkbox";
          pcb.checked = usePass;
          pcb.addEventListener("change", function () { usePass = pcb.checked; });
          var pinfo = document.createElement("div");
          var pt = document.createElement("div");
          pt.className = "etz-modal__addontitle";
          pt.textContent = passLabel + " · " + euro(passPrice) + " p. P.";
          pinfo.appendChild(pt);
          var pd = document.createElement("div");
          pd.className = "etz-modal__addondesc";
          pd.textContent = T("passDesc");
          pinfo.appendChild(pd);
          passRow.appendChild(pcb);
          passRow.appendChild(pinfo);
          card.appendChild(passRow);
        }

        if (boxVisible()) {
          var boxRow = document.createElement("label");
          boxRow.className = "etz-modal__addonbox";
          var cb = document.createElement("input");
          cb.type = "checkbox";
          cb.checked = addonBox;
          cb.addEventListener("change", function () { addonBox = cb.checked; });
          var info = document.createElement("div");
          var t = document.createElement("div");
          t.className = "etz-modal__addontitle";
          t.textContent = boxLabel + " · " + euro(boxPrice);
          info.appendChild(t);
          if (boxDesc) {
            var d = document.createElement("div");
            d.className = "etz-modal__addondesc";
            d.textContent = boxDesc;
            info.appendChild(d);
          }
          boxRow.appendChild(cb);
          boxRow.appendChild(info);
          card.appendChild(boxRow);
        }

        // Zusatzoptionen, gegliedert nach Kategorie (Anreise / Am Abend / Zusatz) — wächst sauber mit.
        function renderAddon(a) {
          if (a.group) {
            // Gruppen-Add-on (Kickstarter): unverbindlich vormerken, schaltet ab genug Zusagen frei.
            var gRow = document.createElement("div");
            gRow.className = "etz-modal__addonbox is-group";
            var gInfo = document.createElement("div");
            var gt = document.createElement("div");
            gt.className = "etz-modal__addontitle";
            gt.textContent = a.label + " · " + euro(a.price) + (a.group.minBackers ? T("minBackers1") + a.group.minBackers + T("minBackers2") : "");
            gInfo.appendChild(gt);
            if (a.description) {
              var gd = document.createElement("div");
              gd.className = "etz-modal__addondesc";
              gd.textContent = a.description;
              gInfo.appendChild(gd);
            }
            gRow.appendChild(gInfo);
            var gb = btn("etz-modal__pledge", T("pledge"), null);
            gb.addEventListener("click", function () {
              var contact = window.prompt(T("pledgePrompt"));
              if (contact == null || contact.indexOf("@") < 0) return;
              gb.disabled = true; gb.textContent = "…";
              fetch("/apps/etz/pledge", {
                method: "POST", headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ productId: evProductId, date: ev.date, addonCode: a.code, contact: contact, qty: modalParty, reservationId: reservationId }),
              }).then(function (r) { if (!r.ok) throw new Error("p"); return r.json(); })
                .then(function () { gb.textContent = T("pledged"); })
                .catch(function () { gb.disabled = false; gb.textContent = T("pledge"); });
            });
            gRow.appendChild(gb);
            card.appendChild(gRow);
            return;
          }
          // Reguläres Add-on (Aufpreis oder Paket) — auswählbar, fließt in die Summe (Schritt 4).
          if (!a.variantId && (a.billing || "prepaid") === "prepaid") return; // ohne Variante nur als Anfrage buchbar
          var aRow = document.createElement("label");
          aRow.className = "etz-modal__addonbox";
          var acb = document.createElement("input");
          acb.type = "checkbox";
          acb.checked = !!selectedAddons[a.code];
          acb.addEventListener("change", function () {
            if (acb.checked) selectedAddons[a.code] = a; else delete selectedAddons[a.code];
          });
          var aInfo = document.createElement("div");
          var at = document.createElement("div");
          at.className = "etz-modal__addontitle";
          var onRequest = (a.billing || "prepaid") !== "prepaid";
          at.textContent = a.label + " · " + euro(a.price) + (a.pricingMode === "package" ? T("pkgTotal") : "") + (onRequest ? T("onRequest") : "");
          aInfo.appendChild(at);
          var adesc = a.description || "";
          if (onRequest) adesc = (adesc ? adesc + " " : "") + T("onRequestDesc");
          else if (a.requiresConfirmation) adesc = (adesc ? adesc + " " : "") + T("confirmFollows");
          if (adesc) {
            var ad = document.createElement("div");
            ad.className = "etz-modal__addondesc";
            ad.textContent = adesc;
            aInfo.appendChild(ad);
          }
          aRow.appendChild(acb);
          aRow.appendChild(aInfo);
          card.appendChild(aRow);
        }

        // Gruppen in fester Reihenfolge mit Klartext-Überschrift; nur nicht-leere Gruppen.
        var addonGroups = [
          { cat: "arrival", label: T("grpArrival") },
          { cat: "evening", label: T("grpEvening") },
          { cat: "addon", label: T("grpAddon") },
        ];
        addonGroups.forEach(function (g) {
          var items = evAddons.filter(function (a) { return (a.category || "addon") === g.cat; });
          if (!items.length) return;
          var h = document.createElement("div");
          h.className = "etz-modal__addons-head";
          h.textContent = g.label;
          card.appendChild(h);
          items.forEach(renderAddon);
        });

        // Pass-Teaser, wenn kein automatischer Pass (Upsell) — gehört zu den Extras.
        if (passUrl && !passAvailable) {
          var disc = document.createElement("div");
          disc.className = "etz-modal__disc";
          var db = document.createElement("div");
          db.className = "etz-modal__disc-b";
          db.style.display = "none";
          db.innerHTML =
            T("passTeaserBody") +
            '<a href="' + passUrl + '">' + T("passTeaserLink") + "</a>";
          var dt = btn("etz-modal__disc-t", T("passTeaserToggle"), function () {
            db.style.display = db.style.display === "none" ? "block" : "none";
          });
          disc.appendChild(dt);
          disc.appendChild(db);
          card.appendChild(disc);
        }

        var actions = document.createElement("div");
        actions.className = "etz-modal__actions";
        actions.appendChild(btn("etz-modal__cancel", T("back"), renderStep2));
        actions.appendChild(btn("etz-modal__go", T("next"), renderStep4));
        card.appendChild(actions);
      }

      // Schritt 4 — Zahlung (Übersicht + Bezahlen). Summe frisch aus der Auswahl.
      function renderStep4() {
        card.innerHTML = header(4);
        mountBanner();

        // Gewählte Zusatzpakete: nur „prepaid" zählt in „jetzt fällig"; Anfrage-Pakete
        // (on_confirm/external) werden separat als „auf Anfrage" gezeigt, nicht jetzt belastet.
        var addonSel = Object.keys(selectedAddons).map(function (k) { return selectedAddons[k]; });
        var prepaidSel = addonSel.filter(function (a) { return (a.billing || "prepaid") === "prepaid"; });
        var reqSel = addonSel.filter(function (a) { return (a.billing || "prepaid") !== "prepaid"; });
        var addonTotal = prepaidSel.reduce(function (s, a) { return s + a.price; }, 0);

        var sum = document.createElement("div");
        sum.className = "etz-modal__sum";
        var rest = 0;
        var addonLines = prepaidSel.map(function (a) { return row2(a.label, euro(a.price)); }).join("")
          + reqSel.map(function (a) { return row2(a.label + T("onRequestParen"), euro(a.price) + T("later")); }).join("");
        if (usePass) {
          var passTotal = modalParty * passPrice;
          var payNowPass = passTotal + (addonBox ? boxPrice : 0) + addonTotal;
          sum.innerHTML =
            row2(modalParty + " × " + euro(passPrice) + T("rowPass"), euro(passTotal)) +
            (addonBox ? row2(boxLabel, euro(boxPrice)) : "") +
            addonLines +
            '<div class="etz-modal__sumline"></div>' +
            row2("<strong>" + T("dueNowFull") + "</strong>", "<strong>" + euro(payNowPass) + "</strong>");
        } else {
          var menuTotal = modalParty * evMenuPrice;
          var depositTotal = modalParty * evDeposit;
          var payNow = depositTotal + (addonBox ? boxPrice : 0) + addonTotal;
          rest = menuTotal - depositTotal;
          sum.innerHTML =
            row2(modalParty + " × " + euro(evMenuPrice) + T("rowMenu"), euro(menuTotal)) +
            (addonBox ? row2(boxLabel, euro(boxPrice)) : "") +
            addonLines +
            '<div class="etz-modal__sumline"></div>' +
            row2("<strong>" + T("dueNow") + "</strong>", "<strong>" + euro(payNow) + "</strong>") +
            (rest > 0 ? row2(T("restOnsite"), euro(rest)) : "");
        }
        if (selectedSeat) sum.insertAdjacentHTML("afterbegin", row2(T("seatSum"), selectedSeat === "theke" ? T("seatSumTheke") : T("seatSumStein")));
        card.appendChild(sum);

        var note = document.createElement("p");
        note.className = "etz-modal__note";
        note.innerHTML = usePass
          ? T("notePass") + cancellation + "<br><br>" + T("noteCheckout")
          : T("noteDeposit") + euro(evDeposit) + T("perPerson") + (rest > 0 ? T("noteRest") : T("noteFull")) + T("noteConfirmed") +
            cancellation + "<br><br>" + T("noteCheckout");
        card.appendChild(note);

        var actions = document.createElement("div");
        actions.className = "etz-modal__actions";
        actions.appendChild(btn("etz-modal__cancel", T("back"), function () { (hasExtras() ? renderStep3 : renderStep2)(); }));
        var go = btn("etz-modal__go", T("toPayment"), null);
        go.addEventListener("click", function () {
          if (remaining <= 0) {
            alert(T("holdGoneAlert"));
            close();
            load();
            return;
          }
          go.disabled = true;
          go.textContent = T("oneMoment");
          checkout(go);
        });
        actions.appendChild(go);
        card.appendChild(actions);
      }

      function checkout(go) {
        var props = {
          Datum: fmtWeekday(ev.date) + ", " + fmtDay(ev.date),
          Personen: modalParty,
          _productId: evProductId,
          _date: ev.date,
          _party: String(modalParty),
          _hold: reservationId,
        };
        // BTA liest Datum + Uhrzeit beim Order→Booking aus SEINEN nativen Feldern "Date"
        // (TT/MM/JJJJ) und "Time" (HH:MM), NICHT aus _date_iso8601 — das ignoriert BTA, die Buchung
        // landet sonst auf Mitternacht (live verifiziert: Order #13240 hatte _date_iso8601 und war
        // trotzdem 00:00; organische Orders tragen Date+Time). Time = Öffnungszeit dieses Erlebnisses
        // (Dinner 18:30 / Metamorphose 17:30), von BTA in Shop-Zeitzone Europe/Berlin gebucht.
        var dp = String(ev.date).split("-"); // "2026-07-31" → ["2026","07","31"]
        if (dp.length === 3) props.Date = dp[2] + "/" + dp[1] + "/" + dp[0];
        props.Time = evOpening;
        if (heldStartAt) props._date_iso8601 = heldStartAt; // Beiwerk, wie das native Widget
        var ms = menuSummary();
        if (ms) props["Menü"] = ms;
        if (fOcc.input.value.trim()) props.Nachricht = fOcc.input.value.trim();
        // Pro-Gast Menü + Allergie als covers (versteckt) + lesbare Allergien-Zusammenfassung
        var covers = menus.map(function (m, i) {
          var a = (allergies[i] || "").trim();
          return { menu: m === "vegetarisch" ? "veg" : "omni", allergy: a || undefined };
        });
        props._covers = JSON.stringify(covers);
        var allergyText = covers
          .map(function (c, i) { return c.allergy ? "Gast " + (i + 1) + " (" + (c.menu === "veg" ? "Veg" : "Omni") + "): " + c.allergy : null; })
          .filter(Boolean)
          .join(" · ");
        if (allergyText) props.Allergien = allergyText;
        // BTA-Übersetzung: das Live-Backend (BookThatApp) kennt genau zwei Formularfelder —
        // Vegetarier-Anzahl + Freitext. Unsere Pro-Gast-Angaben dort hineinspiegeln, damit
        // FOH sie im BTA-Admin UND in der Tagesliste sieht.
        var vegCount = 0;
        for (var vi = 0; vi < menus.length; vi++) if (menus[vi] === "vegetarisch") vegCount++;
        var btaHint = [allergyText, fOcc.input.value.trim()].filter(Boolean).join(" · ");
        var btaAttrs = { "Anzahl vegetarischer Menüs / Number of vegetarian menus": String(vegCount) };
        if (btaHint) btaAttrs["Möchten Sie uns noch etwas mitteilen? Additional notes."] = btaHint;
        // Platzwahl → BTA-Feld „Sitzplatz / Seating" (zweisprachige Voll-Werte, exakt wie im
        // BTA-Formular angelegt; leer = „Ein Tisch", dann wird das Feld nicht gesetzt).
        if (selectedSeat === "theke") btaAttrs["Sitzplatz / Seating"] = "An der offenen Küche / By the open kitchen";
        if (selectedSeat === "stein") btaAttrs["Sitzplatz / Seating"] = "Der Steintisch / The stone table";
        // Pass-Kauf: Pass-Variante statt Anzahlung, gleiche Buchungs-Properties + _pass-Marker.
        if (usePass) props._pass = "1";
        var mainVariant = usePass ? passVariant : evVariant;
        var items = [{ id: Number(mainVariant), quantity: modalParty, properties: props }];
        if (addonBox && boxVisible()) {
          items.push({ id: Number(boxVariant), quantity: 1, properties: { _hold: reservationId } });
        }
        // Zusatzpakete: prepaid → bezahlte Cart-Position; Anfrage-Pakete (on_confirm/external) →
        // NICHT bezahlt, nur als _reqAddons-Codes an der Hauptposition (Erfassung als „pending" im Webhook).
        var reqCodes = [];
        Object.keys(selectedAddons).forEach(function (k) {
          var a = selectedAddons[k];
          if ((a.billing || "prepaid") !== "prepaid") { reqCodes.push(a.code); return; }
          if (!a.variantId) return;
          var ap = { _hold: reservationId, _addon: a.code };
          if (a.requiresConfirmation) ap._confirm = "1";
          items.push({ id: Number(a.variantId), quantity: 1, properties: ap });
        });
        if (reqCodes.length) props._reqAddons = reqCodes.join(",");
        // Alte Reservierungs-Positionen entfernen (Browser-Back nach Checkout, zweiter Anlauf):
        // /cart/add.js ist rein additiv — ohne Aufräumen stapeln sich Anzahlungen im Cart und
        // würden beim Checkout ALLE bezahlt. Erkennungsmerkmal: unsere _hold/_productId-Properties.
        fetch("/cart.js")
          .then(function (r) { return r.json(); })
          .catch(function () { return { items: [] }; })
          .then(function (cart) {
            var stale = (cart.items || []).filter(function (it) {
              var p = it.properties || {};
              return p._hold || p._productId || p._addon;
            });
            // Sequenziell auf 0 setzen (Shopify-Cart-API verträgt keine parallelen Mutationen).
            var chain = Promise.resolve();
            stale.forEach(function (it) {
              chain = chain.then(function () {
                return fetch("/cart/change.js", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ id: it.key, quantity: 0 }),
                }).catch(function () {});
              });
            });
            return chain;
          })
          .then(function () {
            return fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ items: items }),
            });
          })
          .then(function (r) {
            if (!r.ok) throw new Error("cart " + r.status);
            // Cart-Attribute = Order-Attribute: darüber übernimmt BTA die Angaben in die Buchung.
            // Ein Fehlschlag kostet die Veg-/Hinweis-Übernahme → einmal wiederholen; danach trotzdem
            // weiter zum Checkout (die Buchung selbst hängt nicht an den Attributen).
            var upd = function () {
              return fetch("/cart/update.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ attributes: btaAttrs }),
              });
            };
            return upd().then(function (u) { return u.ok ? u : upd(); }).catch(function () { return upd().catch(function () {}); });
          })
          .then(function () {
            window.location.href = "/checkout";
          })
          .catch(function () {
            go.disabled = false;
            go.textContent = T("toPayment");
            alert(T("checkoutFailed"));
          });
      }

      document.body.appendChild(overlay);
      // KEIN Hold beim Öffnen mehr (26.07.2026): in Schritt 1 steht die Personenzahl noch gar
      // nicht fest — der Hold entsteht erst beim „Weiter" nach Schritt 2 (ensureHold dort),
      // mit der tatsächlich gewählten Menge. Nebeneffekt: bloßes Modal-Öffnen (Bots, Neugier)
      // blockiert keine Kapazität mehr.
      renderStep1();
    }

    // Warteliste als Modal — Telefon Pflicht (schnellster Draht), E-Mail optional.
    // Bewusst KEIN Newsletter-Opt-in: dafür bräuchte die App write_customers auf den ganzen
    // Shop (Least-Privilege-Entscheidung Juli 2026); Newsletter-Signup läuft über den Footer.
    function openWaitlist(ev) {
      var evTitle = (ev.product && ev.product.title) || "";
      var overlay = document.createElement("div");
      overlay.className = "etz-modal";
      function close() { overlay.remove(); }
      overlay.addEventListener("click", function (e) { if (e.target === overlay) close(); });
      var card = document.createElement("div");
      card.className = "etz-modal__card";
      overlay.appendChild(card);
      card.addEventListener("click", function (e) {
        if (e.target && e.target.closest && e.target.closest("[data-close]")) close();
      });
      var closeBtnHtml = '<button class="etz-modal__close" type="button" data-close="1" aria-label="' + T("closeAria") + '">×</button>';

      card.innerHTML =
        closeBtnHtml +
        '<div class="etz-modal__eyebrow">' + (evTitle || T("waitlist")) + "</div>" +
        '<div class="etz-modal__title">' + fmtWeekday(ev.date) + ", " + fmtDay(ev.date) + "</div>" +
        '<div class="etz-modal__sub">' + T("wlSub") + "</div>";

      var fName = field(T("wlName"), "text", T("wlNamePh"));
      var fPhone = field(T("wlPhone"), "tel", T("wlPhonePh"));
      var fEmail = field(T("wlEmail"), "email", T("wlEmailPh"));
      card.appendChild(fName.wrap);
      card.appendChild(fPhone.wrap);
      card.appendChild(fEmail.wrap);

      // Anzahl Personen — vorbelegt mit der Auswahl aus der Liste, hier bestätig-/änderbar.
      var wlParty = party;
      var paxWrap = document.createElement("div");
      paxWrap.className = "etz-modal__field";
      var paxLabel = document.createElement("span");
      paxLabel.textContent = T("paxLabel");
      paxWrap.appendChild(paxLabel);
      var paxGrid = document.createElement("div");
      paxGrid.className = "etz-modal__paxgrid";
      function drawWlPax() {
        renderPaxPicker(paxGrid, {
          current: wlParty, max: maxParty, btnClass: "etz-modal__pax", activeClass: "is-on",
          withGroupHint: false,
          onPick: function (k) { wlParty = k; drawWlPax(); },
        });
      }
      drawWlPax();
      paxWrap.appendChild(paxGrid);
      card.appendChild(paxWrap);

      var msg = document.createElement("p");
      msg.className = "etz-modal__note";
      card.appendChild(msg);

      var actions = document.createElement("div");
      actions.className = "etz-modal__actions";
      actions.appendChild(btn("etz-modal__cancel", T("cancel"), close));
      var go = btn("etz-modal__go", T("wlSubmit"), null);
      go.addEventListener("click", function () {
        var name = fName.input.value.trim();
        var phone = fPhone.input.value.trim();
        var email = fEmail.input.value.trim();
        if (!name) { msg.textContent = T("wlNeedName"); fName.input.focus(); return; }
        if (!phone) { msg.textContent = T("wlNeedPhone"); fPhone.input.focus(); return; }
        go.disabled = true;
        go.textContent = T("oneMoment");
        fetch("/apps/etz/waitlist", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            productId: (ev.product && ev.product.id) || productId,
            date: ev.date,
            party: wlParty,
            name: name,
            phone: phone,
            email: email,
            contact: phone || email,
          }),
        })
          .then(function (r) { if (!r.ok) throw new Error("wl"); return r.json(); })
          .then(function () {
            card.innerHTML =
              closeBtnHtml +
              '<div class="etz-modal__title">' + T("wlDone") + "</div>" +
              '<p class="etz-modal__note">' + T("wlDoneNote") + "</p>";
            var a = document.createElement("div");
            a.className = "etz-modal__actions";
            a.appendChild(btn("etz-modal__go", T("close"), close));
            card.appendChild(a);
          })
          .catch(function () {
            go.disabled = false;
            go.textContent = T("wlSubmit");
            msg.textContent = T("wlFailed");
          });
      });
      actions.appendChild(go);
      card.appendChild(actions);

      document.body.appendChild(overlay);
    }

    function renderIntro(intro) {
      if (!introEl) return;
      introEl.innerHTML = "";
      if (intro && intro.text) {
        var h = document.createElement("p");
        h.className = "etz-res__hero";
        h.textContent = intro.text;
        introEl.appendChild(h);
      }
      if (intro && intro.facts) {
        var f = document.createElement("p");
        f.className = "etz-res__facts";
        f.textContent = intro.facts;
        introEl.appendChild(f);
      }
    }

    function dateBlock(date, preview, opening) {
      var b = document.createElement("div");
      b.className = "etz-res__date-block";
      var d = document.createElement("div");
      d.className = "etz-res__date";
      d.innerHTML = '<span class="etz-res__weekday"></span>';
      d.querySelector(".etz-res__weekday").textContent = fmtWeekday(date);
      d.appendChild(document.createTextNode(fmtDay(date)));
      b.appendChild(d);
      // Zeit pro Erlebnis (Metamorphose 17:30 ≠ Dinner 18:30). Ohne Zeit (z. B. Meta-Teaser,
      // für den die App keine openingTime liefert) bleibt die Zeile weg statt falscher 18:30.
      if (opening) {
        var t = document.createElement("div");
        t.className = "etz-res__time" + (preview ? " etz-res__preview" : "");
        t.textContent = T("fromTime") + opening + T("fromTimeSuffix") + (preview ? T("preview") : "");
        b.appendChild(t);
      }
      return b;
    }
    function statusBlock() {
      // Nur der leere Status-Container (für closed/phone/meta); das Knappheits-Wort setzen
      // die Event-Zeilen separat über statusWord().
      var s = document.createElement("div");
      s.className = "etz-res__status-block";
      return s;
    }
    function statusSpan(text, low) {
      var st = document.createElement("span");
      st.className = "etz-res__status" + (low ? " is-low" : "");
      st.textContent = text;
      return st;
    }
    function actionBlock() {
      var a = document.createElement("div");
      a.className = "etz-res__action-block";
      return a;
    }

    function seasonRange(it) {
      if (!it.startDate || !it.endDate) return "";
      function d(iso) { return new Date(iso + "T00:00:00").toLocaleDateString(FMT, { day: "numeric", month: "long" }); }
      return d(it.startDate) + " \u2013 " + d(it.endDate);
    }
    // EN-Overrides für App-Editorial (Saison-Name + -Beschreibung). Das Backend
    // (etz-Perspektiven) liefert diese Felder nur auf Deutsch — /apps/etz/events
    // bekommt keinen locale-Parameter. Bis das Backend lokalisiert (P2), matchen wir
    // den exakten deutschen Text; unbekannte/geänderte Saisons fallen auf Deutsch
    // zurück (nie schlechter als vorher). Schlüssel = exakter DE-Wert aus der App.
    var SEASON_EN = {
      "REICHE VIELFALT": {
        name: "RICH ABUNDANCE",
        subtitle: "Summer — blazing light and overflowing abundance. It is harvest time: with ever more sun, sweetness finds its way into the fruit, and the green of the fields gives way to the golden yellow of ripening grain."
      },
      "DER GARTEN – Vegetarisch": {
        name: "THE GARDEN – Vegetarian",
        subtitle: "Our garden has grown with us over the years — this summer, for the first time, it carries an entire menu. A purely vegetarian etz menu, focused on the garden's abundance. Only from 6 to 22 August."
      },
      "ALLE FARBEN - Jubiläum 5 Jahre etz": {
        name: "ALL THE COLOURS - 5 Years of etz",
        subtitle: "The colourful finale of the growing year: in the orchards, ripe fruit glows in yellow, orange and red. The days grow shorter fast, the meadows noticeably damper in the morning — the first mushrooms herald the coming decay.\nFor the anniversary, a small gift for every table."
      },
      "RÜCKZUG": {
        name: "RETREAT",
        subtitle: "A quiet close. From the cleared gardens and fields we move into the forests — the season of mushrooms has begun. We prepare for winter: drying, ageing, smoking, preserving."
      }
    };
    function seasonName(it) { var o = LANG === "en" && SEASON_EN[it.name]; return o && o.name ? o.name : it.name; }
    function seasonSub(it) { var o = LANG === "en" && SEASON_EN[it.name]; return o && o.subtitle ? o.subtitle : it.subtitle; }
    function seasonHeading(it) {
      var h = document.createElement("div");
      h.className = "etz-res__season";
      var kick = document.createElement("span");
      kick.className = "etz-res__season-kicker";
      // Kontext-Zeile: erklaert, WAS der Block ist. Mit Zeitspanne aus der App, sonst App-Kicker.
      var range = seasonRange(it);
      // it.kicker ist Editorial aus der App (bis P2 deutsch) \u2014 in EN nehmen wir das lokale Wort.
      kick.textContent = range ? (T("seasonKicker") + " \u00b7 " + range) : (LANG === "de" && it.kicker ? it.kicker : T("seasonKicker"));
      h.appendChild(kick);
      h.appendChild(document.createTextNode(seasonName(it)));
      if (it.subtitle) {
        var sub = document.createElement("span");
        sub.className = "etz-res__season-sub";
        sub.textContent = seasonSub(it);
        h.appendChild(sub);
      }
      if (it.menuUrl) {
        var ml = document.createElement("a");
        ml.className = "etz-res__season-menu";
        ml.href = it.menuUrl;
        ml.textContent = T("menuLink");
        h.appendChild(ml);
      }
      return h;
    }

    function load() {
      list.innerHTML = '<p class="etz-res__muted">' + T("loading") + "</p>";
      fetch("/apps/etz/events?productId=" + encodeURIComponent(productId) + "&party=" + encodeURIComponent(party) + (refToken ? "&ref=" + encodeURIComponent(refToken) : ""))
        .then(function (r) {
          if (!r.ok) throw new Error("http " + r.status);
          return r.json();
        })
        .then(function (data) {
          if (data.openingTime) openingTime = data.openingTime;
          if (data.phone) phone = data.phone;
          // Server-Storno-Text ist deutsches Editorial → nur in DE übernehmen (P2: mehrsprachig).
          if (data.cancellation && LANG === "de") cancellation = data.cancellation;
          dropInfo = data.drop || null;
          seatsData = data.seats || { thekeMax: 3, byDate: {}, splits: {} };
          vegRanges = Array.isArray(data.vegOnly) ? data.vegOnly : [];
          renderIntro(data.intro);
          render(data.items || []);
        })
        .catch(function () {
          // Graceful Degradation: App/DB nicht erreichbar → Telefon-Fallback statt leerer Liste
          list.innerHTML = fallbackPhone
            ? '<p class="etz-res__muted">' + T("fallbackPhone1") + '<a class="etz-res__phone" href="tel:' +
              fallbackPhone.replace(/\s/g, "") +
              '">' + fallbackPhone + "</a></p>"
            : '<p class="etz-res__muted">' + T("fallbackGeneric") + "</p>";
        });
    }

    // Drop-Countdown + „Erinnere mich" — erscheint, wenn eine nächste öffentliche Welle ansteht.
    function dropBanner() {
      if (!dropInfo || !dropInfo.nextPublicAt) return null;
      var when = new Date(dropInfo.nextPublicAt);
      if (isNaN(when.getTime())) return null;
      var wrap = document.createElement("div");
      wrap.className = "etz-res__drop";
      var head = document.createElement("div");
      head.className = "etz-res__drop-head";
      var cd = document.createElement("strong");
      head.appendChild(document.createTextNode(T("dropHead")));
      head.appendChild(cd);
      wrap.appendChild(head);
      function tick() {
        var s = Math.floor((when.getTime() - Date.now()) / 1000);
        if (s <= 0) { cd.textContent = T("now"); return; }
        var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
        cd.textContent = (d > 0 ? d + T("days") : "") + h + T("hrs") + m + T("mins");
      }
      tick();
      var iv = setInterval(function () { if (!document.body.contains(wrap)) { clearInterval(iv); return; } tick(); }, 60000);
      // Erinnere-mich: E-Mail erfassen (DropSubscriber) — kein Konto nötig.
      var f = document.createElement("div");
      f.className = "etz-res__drop-form";
      var inp = document.createElement("input");
      inp.type = "email";
      inp.placeholder = T("dropEmailPh");
      var b = btn("etz-res__drop-btn", T("remindMe"), null);
      b.addEventListener("click", function () {
        var email = inp.value.trim();
        if (!email || email.indexOf("@") < 0) { inp.focus(); return; }
        b.disabled = true; b.textContent = "…";
        fetch("/apps/etz/notify", {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ productId: productId, email: email }),
        }).then(function () { f.innerHTML = '<span class="etz-res__drop-ok">' + T("notified") + "</span>"; })
          .catch(function () { b.disabled = false; b.textContent = T("remindMe"); });
      });
      f.appendChild(inp);
      f.appendChild(b);
      wrap.appendChild(f);
      return wrap;
    }

    function render(items) {
      if (!items.length) {
        list.innerHTML = "";
        var db0 = dropBanner();
        if (db0) list.appendChild(db0);
        var empty = document.createElement("p");
        empty.className = "etz-res__muted";
        empty.textContent = T("noEvenings");
        list.appendChild(empty);
        return;
      }
      list.innerHTML = "";
      var db1 = dropBanner();
      if (db1) list.appendChild(db1);
      // Jahreszeiten-Gruppen: die erste (aktuelle) offen, künftige zugeklappt —
      // hält die Seite bei langem Buchungshorizont (200+ Abende) kurz.
      // Ohne season-Items fällt alles in die immer sichtbare Liste zurück.
      var groups = [];
      var target = list;
      function startGroup(it) {
        var d = document.createElement("details");
        d.className = "etz-res__seasonblock";
        var s = document.createElement("summary");
        s.className = "etz-res__seasonsummary";
        s.appendChild(seasonHeading(it));
        var count = document.createElement("span");
        count.className = "etz-res__season-count";
        s.appendChild(count);
        // Menükarten-Link in der Überschrift soll navigieren, nicht auf-/zuklappen
        var ml = s.querySelector(".etz-res__season-menu");
        if (ml) ml.addEventListener("click", function (e) { e.stopPropagation(); });
        d.appendChild(s);
        var body = document.createElement("div");
        d.appendChild(body);
        list.appendChild(d);
        groups.push({ el: d, body: body, count: count });
        target = body;
      }
      items.forEach(function (it) {
        if (it.type === "season") {
          startGroup(it);
          return;
        }
        if (it.type === "closedRange") {
          var band = document.createElement("div");
          band.className = "etz-res__closedband";
          band.textContent = it.label;
          target.appendChild(band);
          return;
        }

        var row = document.createElement("div");
        row.className = "etz-res__row";
        if (it.date && weekdayNum(it.date) === 4) row.className += " is-week";
        var rowOpening = (it.product && it.product.openingTime) || (it.type === "meta" ? (it.openingTime || "") : openingTime);
      row.appendChild(dateBlock(it.date, it.type === "event" && it.preview, rowOpening));

        if (it.type === "event") {
          if (!it.available) row.className += " is-out";
          var special = it.product && it.product.type && it.product.type !== "dinner";
          if (special) {
            row.className += " is-special";
            var tag = document.createElement("div");
            tag.className = "etz-res__special-tag";
            tag.textContent = it.product.title;
            row.appendChild(tag);
          }
          // Status = Information (Versalien-Label links neben der Aktion), Aktion = immer gleiches
          // Wort ("Reservieren"/"Warteliste"). Die Knappheit steckt NICHT mehr im Linktext —
          // Entscheidung Juli 2026, die wechselnde Link-Beschriftung war am lebenden Widget verwirrend.
          var aE = actionBlock();
          var word = statusWord(it.state, it.product && it.product.type); // "… Tisch" (Dinner) / "… Platz" (Shared)
          if (word) aE.appendChild(statusSpan(word, LOW[it.state]));
          var bookable = it.available && (!it.product || it.product.variantId);
          if (bookable) {
            var link = btn("etz-res__link", ACTION(it.state), null);
            link.addEventListener("click", function () { openModal(it); });
            aE.appendChild(link);
          } else if (it.available) {
            // verfügbar, aber (noch) keine Shopify-Variante → kein Online-Klick
            var soon = document.createElement("span");
            soon.className = "etz-res__status";
            soon.textContent = T("onRequestStatus");
            aE.appendChild(soon);
          } else {
            var wl = btn("etz-res__link", T("waitlist"), null);
            wl.addEventListener("click", function () { openWaitlist(it); });
            aE.appendChild(wl);
          }
          row.appendChild(aE);
        } else if (it.type === "meta") {
          row.className += " is-meta";
          // "Metamorphose — von Most zu Essig" → Versalien-Tag "Metamorphose" + Thema als Link.
          // Ohne Gedankenstrich bleibt das ganze Label der Linktext (Redaktion ist Freitext).
          var mParts = String(it.label || "").split("—");
          var mTag = mParts.length > 1 ? mParts.shift().trim() : "";
          var mText = mParts.join("—").trim() || T("metaDefault");
          var aM = actionBlock();
          if (mTag) aM.appendChild(statusSpan(mTag, false));
          var ml = document.createElement("a");
          ml.className = "etz-res__link etz-res__meta";
          ml.href = it.url || "#";
          ml.textContent = mText + " ›";
          aM.appendChild(ml);
          row.appendChild(aM);
        } else if (it.type === "closed") {
          row.className += " is-out";
          row.appendChild(statusBlock());
          var aC = actionBlock();
          var cl = document.createElement("span");
          cl.className = "etz-res__status";
          cl.textContent = it.label;
          aC.appendChild(cl);
          row.appendChild(aC);
        } else if (it.type === "phone") {
          row.appendChild(statusBlock());
          var aP = actionBlock();
          var pl = document.createElement("a");
          pl.className = "etz-res__link etz-res__phone";
          pl.href = "tel:" + String(it.phone || phone || "").replace(/\s/g, "");
          pl.textContent = T("byPhone") + (it.phone || phone);
          aP.appendChild(pl);
          row.appendChild(aP);
        }

        target.appendChild(row);
      });

      // Jahreszeiten aufklappen, bis genügend Termine offen liegen — nicht stur nur die
      // erste. So wirkt die Liste auch am Saison-Ende (wenige Rest-Abende) nie zu leer.
      // Zugeklappte Gruppen zeigen die Zahl ihrer Abende.
      var MIN_OPEN_ROWS = 8;
      var shownRows = 0;
      groups.forEach(function (g, i) {
        var n = g.body.querySelectorAll(".etz-res__row").length;
        g.count.textContent = n ? n + (n === 1 ? T("evening") : T("evenings")) : "";
        var openThis = (i === 0) || (shownRows < MIN_OPEN_ROWS);
        g.el.open = openThis;
        if (openThis) shownRows += n;
      });

      if (giftcardUrl) {
        var gc = document.createElement("a");
        gc.className = "etz-res__giftcard";
        gc.href = giftcardUrl;
        gc.textContent = T("giftcard");
        list.appendChild(gc);
      }
    }

    load();
  }

  document.querySelectorAll("[data-etz-res]").forEach(init);
})();

// resync a1ffdf4

// cache-bump e88210e
